import { environment } from 'src/environments/environment';

const EXCLUDED_URL_FRAGMENTS = ['/oauth/token', '/authorize', '/.well-known'];

/** Returns true when the request targets Auth0 or OAuth endpoints that must not reset inactivity. */
export function shouldSkipInactivityForRequest(url: string): boolean {
  if (EXCLUDED_URL_FRAGMENTS.some((fragment) => url.includes(fragment))) {
    return true;
  }

  const auth0Domain = (environment.auth0.domain ?? '').trim();
  if (!auth0Domain) {
    return false;
  }

  try {
    const parsed = new URL(url, globalThis.location.origin);
    return parsed.hostname === auth0Domain;
  } catch {
    return url.includes(auth0Domain);
  }
}
